import { RequestTheme } from '../contexts/jurisdiction-context';

const applyTheme: (variables: RequestTheme) => void = (variables) => {
    Object.entries(variables).forEach(([className, rules]) => {
        document.querySelectorAll<HTMLElement>(`.${className}`).forEach(($element) => {
            Object.entries(rules).forEach(([property, value]) => {
                $element.style.setProperty(property, value);
            });
        })
    })
};

export default applyTheme;